import styled from 'styled-components';

export const Card = styled.div`
  .video-react {
    padding-top: 140px !important;
  }

  b {
    display: block;
  }
  .card-buttons {
    padding: 0 20px 20px;

    a {
      margin-right: 10px;
    }
  }
`;

export const Filter = styled.div`
  float: right;
  font-size: 14px;
  color: #a7b3bb;

  span {
    margin-right: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EventPosts/styles.js